import api from "actions/api.js"


export function getNotes(personid) {
    return api(`profile/${personid}/notes`)
}

export function postNote(note) {
    const { personid, userid, value } = note

    return api("personnote",
        {
            method: "POST",
            body: JSON.stringify({ personid, userid, value })
        })
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/notes/api.js
 **/